import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, Card } from 'react-bootstrap';
import LeftPanelDraggable from './LeftPanelDraggable';
import '../POTemplate.css';

const controls = [
  { id: 1, type: 'TextArea', label: 'Text Area' },
  { id: 2, type: 'Textbox', label: 'Textbox' },
  { id: 3, type: 'Dropdown', label: 'Dropdown' },
  { id: 4, type: 'Checkbox', label: 'Checkbox' },
  { id: 5, type: 'RadioButton', label: 'Radio Button' },
  { id: 6, type: 'DatePicker', label: 'Date Picker' },
  { id: 7, type: 'Section', label: '1 Column Section', columns: 1 },
  { id: 8, type: 'Section', label: '2 Column Section', columns: 2 },
  { id: 9, type: 'Section', label: '3 Column Section', columns: 3 },
  { id: 10, type: 'Section', label: '4 Column Section', columns: 4 },
];

export default function LeftPanel() {
  const { t } = useTranslation('purchase-order');
  const [forActiveClass, setForActiveClass] = useState(true);

  const forActivekey = () => {
    setForActiveClass(!forActiveClass);
  };

  return (
    <div className="menu-open left-section p-10 bg-white">
      <div className="move-cursor">
        <Accordion defaultActiveKey="1">
          <Card className="po-temp-menu-card rounded-0">
            <Accordion.Toggle variant="link" eventKey="1" onClick={forActivekey} className="d-flex btn-custom-module-tab text-center active">
              {t('PO_TEMPLATE.DETAIL_PAGE.CONTROLS')}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <ul className="control-ul" style={{ listStyle: 'none' }}>
                {controls?.map((ele) => {
                  return (
                    <li key={`${ele?.id}`}>
                      <LeftPanelDraggable control={ele} />
                    </li>
                  );
                })}
              </ul>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </div>
  );
}
